<div class="p-4 w-full flex-row justify-start items-start gap-4 inline-flex">
  <div class="text-black text-lg font-bold leading-normal">{{ to.label }}</div>
  <div class="flex items-center cursor-pointer ml-auto">
    <button *ngIf="to.hasCsvImport" xilo-button (click)="openDromo()">
      <div class="flex justify-center items-center">
        <mat-icon class="text-lg -mt-1">description</mat-icon>
        <div class="text-sm pl-1">Import CSV</div>
      </div>
    </button>
  </div>
</div>
<xilo-accordion class="flex flex-col rounded bg-white" cdkDropList (cdkDropListDropped)="drop($event)">
  <xilo-accordion-panel class="bg-white" *ngFor="let fg of field.fieldGroup; let i = index;" [attr.id]="fg.id" (openChanged)="openChanged(fg.id, $event)" [open]="openedAccordion?.has(fg?.id)" cdkDrag>
    <xilo-accordion-title>
      <div class="flex flex-row w-full pr-2">
        <span class="drag-indicator flex items-center" (click)="$event.stopPropagation()" cdkDragHandle>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 8 12" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.00008 0.666992C1.26675 0.666992 0.666748 1.26699 0.666748 2.00033C0.666748 2.73366 1.26675 3.33366 2.00008 3.33366C2.73341 3.33366 3.33342 2.73366 3.33342 2.00033C3.33342 1.26699 2.73341 0.666992 2.00008 0.666992ZM0.666748 6.00033C0.666748 5.26699 1.26675 4.66699 2.00008 4.66699C2.73341 4.66699 3.33342 5.26699 3.33342 6.00033C3.33342 6.73366 2.73341 7.33366 2.00008 7.33366C1.26675 7.33366 0.666748 6.73366 0.666748 6.00033ZM2.00008 11.3337C2.73341 11.3337 3.33342 10.7337 3.33342 10.0003C3.33342 9.26699 2.73341 8.66699 2.00008 8.66699C1.26675 8.66699 0.666748 9.26699 0.666748 10.0003C0.666748 10.7337 1.26675 11.3337 2.00008 11.3337ZM7.33341 2.00033C7.33341 2.73366 6.73341 3.33366 6.00008 3.33366C5.26675 3.33366 4.66675 2.73366 4.66675 2.00033C4.66675 1.26699 5.26675 0.666992 6.00008 0.666992C6.73341 0.666992 7.33341 1.26699 7.33341 2.00033ZM6.00008 4.66699C5.26675 4.66699 4.66675 5.26699 4.66675 6.00033C4.66675 6.73366 5.26675 7.33366 6.00008 7.33366C6.73341 7.33366 7.33341 6.73366 7.33341 6.00033C7.33341 5.26699 6.73341 4.66699 6.00008 4.66699ZM4.66675 10.0003C4.66675 9.26699 5.26675 8.66699 6.00008 8.66699C6.73341 8.66699 7.33341 9.26699 7.33341 10.0003C7.33341 10.7337 6.73341 11.3337 6.00008 11.3337C5.26675 11.3337 4.66675 10.7337 4.66675 10.0003Z"
              fill="#DADADA"
            ></path>
          </svg>
        </span>
        <span class="pl-2 flex items-center">{{ to.label | repeatTitle: fg:to:i:fg?.parent?.formControl?.controls[i]?.value }}</span>
        <span class="flex items-center" *ngIf="!fg?.parent?.formControl?.controls[i]?.valid">
          <mat-icon class="text-lg -mt-1 ml-2 text-red-500"> warning </mat-icon>
        </span>
        <div class="ml-auto w-8 border-r" *ngIf="field?.fieldGroup?.length > 1">
          <mat-icon [matMenuTriggerFor]="more" (click)="$event.stopPropagation()" class="pr-2 mt-1 hover:text-black"> more_vert </mat-icon>
          <mat-menu #more="matMenu" xPosition="before" class="fonr-medium text-sm applicant-dropup">
            <button mat-menu-item (click)="remove(i)">
              <div class="text-red-500 text-sm flex items-center">
                <span class="pr-3"><img src="../../assets/icon/delete-red.svg" /></span>
                Delete
              </div>
            </button>
          </mat-menu>
        </div>
      </div>
    </xilo-accordion-title>

    <xilo-accordion-content>
      <formly-field [field]="fg"></formly-field>
    </xilo-accordion-content>
  </xilo-accordion-panel>
</xilo-accordion>
<div class="p-4 w-full border-t border-gray-200 flex justify-between items-center">
  <button class="add-btn !flex items-center" xilo-button type="button" [style.background-color]="brandColor" [style.color]="brandColor ? 'white' : ''" color="primary-light" (click)="addMore()">
    <mat-icon class="text-lg -mt-1">add</mat-icon>
    <div class="text-sm pl-1">{{ to.label | repeatAddButton }}</div>
    <ng-container *ngIf="isReadyToAddRepeatItem$ | async">
      <div class="flex flex-nowrap items-center gap-1 ml-2">
        <span class="bg-white/20 px-[4px] py-[4px] rounded inline-flex items-center">
          <ng-container *ngIf="isMac; else ctrlKey">
            <img src="/assets/icons/command.svg" alt="Command key" class="w-[12px] h-[12px]" />
          </ng-container>
          <ng-template #ctrlKey>
            <span [style.color]="brandColor ? 'white' : ''" class="text-[10px] font-[400] leading-[12px]">Ctrl</span>
          </ng-template>
        </span>
        <span class="bg-white/20 px-[4px] py-[4px] rounded inline-flex items-center">
          <img src="/assets/icons/plus-white.svg" alt="Command key" class="w-[12px] h-[12px]" />
        </span>
      </div>
    </ng-container>
  </button>
</div>

<xilo-mono-csv-importer #importer [importerName]="to.label" [licenseKey]="dromoLicenseKey" (completed)="onCompletedImport($event)" [user]="activeUser"></xilo-mono-csv-importer>
